<template>
  <div class="">
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">
      {{ params.data.patient.first_name }}
      {{ params.data.patient.last_name }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CellRendererPatient',
  methods: {

  },
  computed: {
    url () {
      return '/patients/patient/view/'+this.params.data.patient.id

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
